module.exports = __webpack_public_path__ + "img/assignment.9b4e5c70.svg";